import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { endConference } from "../../../base/conference/actions.any";
import { isLocalParticipantModerator } from "../../../base/participants/functions";
import { BUTTON_TYPES } from "../../../base/ui/constants.web";
import { isInBreakoutRoom } from "../../../breakout-rooms/functions";
import { openDialog } from "../../../base/dialog/actions";
import Dialog from "../../../base/ui/components/web/Dialog";
import { HangupContextMenuItem } from "./HangupContextMenuItem";
import { authApi } from "../../../auth/api";
import { setHangupMenuVisible, setLeavingOverlay } from "../../actions.web";
/**
 * Confirmation dialog for ending conference.
 */
const EndConferenceDialog = ({ onSubmit }) => {
    return (React.createElement(Dialog, { cancel: { translationKey: 'dialog.Cancel', hidden: false }, hideCloseButton: false, ok: { translationKey: 'dialog.Yes' }, onSubmit: onSubmit, titleKey: 'toolbar.endConference' },
        React.createElement("div", { style: { padding: '16px 0', textAlign: 'center', fontSize: '0.95rem' } }, "\u0622\u06CC\u0627 \u0645\u0637\u0645\u0626\u0646 \u0647\u0633\u062A\u06CC\u062F\u061F")));
};
/**
 * Button to end the conference for all participants.
 *
 * @returns {JSX.Element} - The end conference button.
 */
export const EndConferenceButton = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const _isLocalParticipantModerator = useSelector(isLocalParticipantModerator);
    const _isInBreakoutRoom = useSelector(isInBreakoutRoom);
    const handleEndConferenceClick = useCallback(() => {
        // Close the hangup menu immediately
        dispatch(setHangupMenuVisible(false));
        // Open confirmation dialog
        dispatch(openDialog('EndConferenceDialog', EndConferenceDialog, {
            onSubmit: async () => {
                dispatch(setLeavingOverlay(true));
                // فوراً کنفرانس رو برای همه پایان می‌دیم
                dispatch(endConference());
                // بعد API رو صدا می‌زنیم (fire and forget)
                const roomName = window.location.pathname.slice(1).toLowerCase();
                if (roomName) {
                    authApi.exitAll(roomName).catch((e) => {
                        console.warn("exitAll API failed", e);
                    });
                }
                // کمی صبر می‌کنیم تا سیگنال ارسال بشه
                await new Promise(resolve => setTimeout(resolve, 500));
                // بعد به صفحه اصلی می‌ریم
                window.location.href = '/';
            }
        }));
    }, [dispatch]);
    return (React.createElement(React.Fragment, null, !_isInBreakoutRoom && _isLocalParticipantModerator && (React.createElement(HangupContextMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.endConference"), buttonKey: props.buttonKey, buttonType: BUTTON_TYPES.DESTRUCTIVE, label: t("toolbar.endConference"), notifyMode: props.notifyMode, onClick: handleEndConferenceClick }))));
};
